export default "__VITE_ASSET__BdihVk2Q__"